import PropTypes from "prop-types";
import ImageTile from "../../atoms/imageTile";
import ButtonComponent from "../../atoms/button";

/**
 * AddItemButton component.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {number} props.selectedItem - The selected item.
 * @param {function} props.setSelectedItem - The function to set the selected item.
 * @returns {JSX.Element} The AddItemButton component.
 */
const AddItemButton = ({ selectedItem, setSelectedItem, onRemoveItem, parentStyle }) => {
  /**
   * Handle the change in item count.
   *
   * @param {number} count - The new item count.
   */
  const onItemCountChange = (count) => {
    if (count < 0) return;
    setSelectedItem(count);
  };

  if (!selectedItem) {
    return (
      <ButtonComponent
        onClick={() => onItemCountChange(1)}
        buttonVariant="iconWithTextOutlined"
        classes="text-fnp-300 border border-green-100 py-8 px-16 hover:bg-fnp-100 ease-in-out duration-300"
        label={"ADD"}
        size=""
        labelStyle="text-14 font-600"
      />
    );
  }

  /**
   * Handles the removal or decrement of the selected item count.
   * If the selected item count is 1, it triggers the removal of the item.
   * Otherwise, it decrements the item count by one.
   */
  const onHandleRemoveORsubtract = () => {
    if (selectedItem === 1) {
      return onRemoveItem(selectedItem);
    }
    return onItemCountChange(selectedItem - 1);
  };
  // "flex w-max items-center gap-13 rounded-8 border-1 p-3 md:gap-10"

  return (
    <div
      className={
        parentStyle ||
        "flex h-[32px] w-[85px] items-center justify-between gap-10 rounded-8 border-1 border-lightOliveGreen p-4"
      }
    >
      <ImageTile
        imgSrc={selectedItem === 1 ? "/icons/trash.svg" : "/icons/minus-square.svg"}
        imgHeight={22}
        imgWidth={22}
        imgAlt="trash-icon"
        imgClass="cursor-pointer w-[20px] h-[20px] shrink-0"
        onClick={onHandleRemoveORsubtract}
        isAdjustWidth={true}
      />

      <span>{selectedItem}</span>
      <ImageTile
        imgSrc="/icons/add-square.svg"
        imgHeight={24}
        imgWidth={24}
        imgAlt="add-square-icon"
        imgClass="cursor-pointer w-[20px] h-[20px] shrink-0"
        onClick={() => onItemCountChange(selectedItem + 1)} // Increase count by 1
        isAdjustWidth={true}
      />
    </div>
  );
};

AddItemButton.propTypes = {
  selectedItem: PropTypes.number.isRequired,
  setSelectedItem: PropTypes.func.isRequired,
  onRemoveItem: PropTypes.func.isRequired,
  parentStyle: PropTypes.string,
};

export default AddItemButton;
